<template>
  <PageContainer title="Cadastro de perímetro">
    <div slot="header">
      <Button
        @handle:click="modal.open = !modal.open"
        type="button"
        text="Novo perímetro"
        color="primary"
        :disabled="loading"
      >
        <Plus :size="18" />
      </Button>
    </div>

    <Box class="perimetro-container" space="medium">
      <Table :headers="['#ID', 'Perímetro', 'Ações']">
        <tr v-if="registeredPoly.length < 1">
          <td rowspan="3">Sem resultados</td>
        </tr>
        <tr v-else v-for="polygon in registeredPoly" :key="polygon.id">
          <td>#{{ polygon.id }}</td>
          <td>{{ polygon.descricao }}</td>
          <td>
            <div class="actions">
              <div>
                <IconButton
                  @handle:click="show(polygon.coordenadas)"
                  color="primary"
                  title="Visualizar"
                  :disabled="editId !== null"
                >
                  <MapMarkerRadiusOutline :size="19" />
                </IconButton>
              </div>
              <div
                v-if="editId !== polygon.id"
                :disabled="editId !== null && editId !== polygon.id"
              >
                <IconButton @handle:click="allowEdit(polygon)" color="secondary" title="Editar">
                  <PencilOutline :size="19" />
                </IconButton>
              </div>
              <div v-if="editId === polygon.id" @click="updatePolygon(polygon.id)">
                <IconButton
                  @handle:click="updatePolygon(polygon.id)"
                  color="success"
                  title="Salvar"
                >
                  <ContentSaveOutline :size="19" />
                </IconButton>
              </div>
              <div>
                <IconButton
                  @handle:click="openDeleteModal(polygon.id)"
                  color="danger"
                  title="Excluir"
                  :disabled="editId !== null"
                >
                  <TrashCanOutline :size="19" />
                </IconButton>
              </div>
            </div>
          </td>
        </tr>
      </Table>

      <div class="map-container">
        <div class="search">
          <legend>Consultar endereço</legend>

          <input
            id="autocomplete"
            class="input"
            type="text"
            placeholder="Consultar endereço"
            v-model="search"
          />
        </div>

        <div id="map"></div>
      </div>
    </Box>

    <ModalCadastro
      v-if="this.modal.open"
      v-on:close="closeModal()"
      v-on:search="search($event)"
      :CfcCoordinates="cfc"
    >
    </ModalCadastro>

    <ConfirmModal
      ref="confirmModal"
      title="Remover perímetro"
      message="Tem certeza que deseja remover esse perímetro? esta ação é irreversível e o perímetro não poderá ser recuperado!"
      :onConfirm="deletePolygon"
    />

    <script async type="application/javascript">
      ;(g => {
        var h,
          a,
          k,
          p = 'The Google Maps JavaScript API',
          c = 'google',
          l = 'importLibrary',
          q = '__ib__',
          m = document,
          b = window
        b = b[c] || (b[c] = {})
        var d = b.maps || (b.maps = {}),
          r = new Set(),
          e = new URLSearchParams(),
          u = () =>
            h ||
            (h = new Promise(async (f, n) => {
              await (a = m.createElement('script'))
              e.set('libraries', [...r] + '')
              for (k in g)
                e.set(
                  k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()),
                  g[k]
                )
              e.set('callback', c + '.maps.' + q)
              a.src = `https://maps.${c}apis.com/maps/api/js?` + e
              d[q] = f
              a.onerror = () => (h = n(Error(p + ' could not load.')))
              a.nonce = m.querySelector('script[nonce]')?.nonce || ''
              m.head.append(a)
            }))
        d[l]
          ? console.warn(p + ' only loads once. Ignoring:', g)
          : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)))
      })({
        key: 'AIzaSyC5JcoGlTUPTGM_8GK9EKiPByA2WVZ2FKA',
        v: 'weekly',
      })
    </script>
  </PageContainer>
</template>

<script>
import ContentSaveOutline from 'icons/ContentSaveOutline'
import MapMarkerRadiusOutline from 'icons/MapMarkerRadiusOutline'
import PencilOutline from 'icons/PencilOutline'
import Plus from 'icons/Plus'
import TrashCanOutline from 'icons/TrashCanOutline'
import Box from '../core/Box'
import Button from '../core/Button'
import ConfirmModal from '../core/ConfirmModal.vue'
import IconButton from '../core/IconButton'
import PageContainer from '../core/PageContainer'
import Table from '../core/Table'
import ModalCadastro from './modal/AdicionarPerimetro.vue'

export default {
  components: {
    PageContainer,
    Box,
    Button,
    Table,
    IconButton,
    Plus,
    MapMarkerRadiusOutline,
    TrashCanOutline,
    PencilOutline,
    ContentSaveOutline,
    ModalCadastro,
    ConfirmModal,
  },
  name: 'GoogleMap',
  data() {
    return {
      registeredPoly: [],
      modal: {
        open: false,
      },
      loading: false,
      cfc: {
        lat: '',
        lng: '',
      },
      map: null,
      polySelected: [],
      poly: null,
      editId: null,
      coordinatesSelected: [],
      markers: [],
      search: null,
    }
  },
  async mounted() {
    await this.loadData()
    await this.loadCFC()
    await this.initMap()
  },
  methods: {
    async initMap() {
      const { Map } = await google.maps.importLibrary('maps')
      const { Autocomplete } = await google.maps.importLibrary('places')

      if (this.registeredPoly.length) {
        this.show(this.registeredPoly[0].coordenadas)
      }

      const { lat, lng } = this.cfc

      this.map = new Map(document.getElementById('map'), {
        center: { lat, lng },
        zoom: 15,
        mapId: 'novocfc',
      })

      this.poly = new google.maps.Polyline({
        strokeColor: '#000000',
        strokeOpacity: 1.0,
        strokeWeight: 3,
      })

      this.poly.setMap(this.map)

      this.map.addListener('click', this.addLatLng)

      const input = document.getElementById('autocomplete')

      this.autocomplete = new google.maps.places.Autocomplete(input, {
        fields: ['geometry', 'formatted_address'],
        types: ['geocode'],
      })

      this.autocomplete.bindTo('bounds', this.map)

      this.autocomplete.addListener('place_changed', this.handlePlaceChanged)

      await this.sleep(2000)

      const pacContainers = document.querySelectorAll('.pac-container')
      pacContainers.forEach(pac => {
        pac.style.zIndex = '1052'
      })
    },
    handlePlaceChanged() {
      const place = this.autocomplete.getPlace()

      if (!place.geometry || !place.geometry.location) {
        console.error('Lugar inválido')
        return
      }

      const location = place.geometry.location

      this.search = place.formatted_address

      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport)
      } else {
        this.map.setCenter(location)
        this.map.setZoom(17)
      }

      this.marker = new google.maps.Marker({
        map: this.map,
        position: location,
        icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
      })
    },
    async addLatLng(event) {
      const { AdvancedMarkerElement } = await google.maps.importLibrary('marker')
      const latLng = event.latLng

      const existingMarkerIndex = this.coordinatesSelected.findIndex(
        coord => coord.lat === latLng.lat() && coord.lng === latLng.lng()
      )

      if (existingMarkerIndex !== -1) {
        this.markers[existingMarkerIndex].setMap(null)
        const path = this.poly.getPath()
        path.removeAt(existingMarkerIndex)
        this.markers.splice(existingMarkerIndex, 1)
        this.coordinatesSelected.splice(existingMarkerIndex, 1)
        return
      }

      this.coordinatesSelected.push({ lat: latLng.lat(), lng: latLng.lng() })
      const path = this.poly.getPath()
      path.push(latLng)

      const newMarker = new AdvancedMarkerElement({
        position: latLng,
        title: '#' + path.getLength(),
        map: this.map,
      })

      this.markers.push(newMarker)

      newMarker.addListener('click', () => {
        this.removeMarker(newMarker)
      })
    },
    removeMarker(marker) {
      marker.setMap(null)

      const index = this.markers.indexOf(marker)

      if (index > -1) {
        this.markers.splice(index, 1)
        this.coordinatesSelected.splice(index, 1)

        this.poly.getPath().removeAt(index)
      }
    },
    allowEdit(poly) {
      this.editId = poly.id
      this.removePolySelected()
    },
    updatePolygon(id) {
      this.editId = null
      const coordenadas = this.coordinatesSelected
      this.coordinatesSelected = []
      this.removePoly()
      this.removeMarkers()

      const data = {
        coordinates: coordenadas,
      }
      this.$http
        .post(`${process.env.VUE_APP_URL_API_V2}/perimetros/update/${id}`, data)
        .then(response => {
          const index = this.registeredPoly.findIndex(
            element => element.id === response.body.data.id
          )
          if (index !== -1) {
            this.$set(this.registeredPoly, index, response.body.data)
          }
          this.show(response.body.data.coordenadas)
        })
    },
    async loadCFC() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/user/cfc`).then(response => {
        const res = response.body.dados

        this.cfc = {
          lat: parseFloat(res.lat),
          lng: parseFloat(res.lon),
        }
      })
    },
    async loadData() {
      await this.$http.get(process.env.VUE_APP_URL_API_V2 + '/perimetros/index').then(response => {
        this.registeredPoly = JSON.parse(JSON.stringify(response.body.data))
      })
    },
    async show(coordenadas) {
      this.removePolySelected()

      const perimetro = await coordenadas.map(coord => {
        return { lat: parseFloat(coord['latitude']), lng: parseFloat(coord['longitude']) }
      })

      this.polySelected = new google.maps.Polygon({
        paths: perimetro,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
      })

      this.polySelected.setMap(this.map)

      const center = this.calculatePolygonCenter(perimetro)

      this.map.setCenter(center)
      this.map.setZoom(15)
    },
    openDeleteModal(id) {
      this.$refs.confirmModal.open(id)
    },
    deletePolygon(id) {
      this.$http
        .delete(`${process.env.VUE_APP_URL_API_V2}/perimetros/delete/${id}`)
        .then(response => {
          this.$refs.confirmModal.close()

          this.$toasted.show('Perimetro removido!', {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
          this.loadData()
        })
    },
    removePolySelected() {
      if (typeof this.polySelected.length == 'undefined') {
        this.polySelected.setMap(null)
      }
    },
    removePoly() {
      if (typeof this.poly.length == 'undefined') {
        this.poly.setMap(null)
        this.initMap()
      }
    },
    removeMarkers() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null)
      }
    },
    closeModal() {
      this.modal.open = false
      this.loadData()
    },
    calculatePolygonCenter(perimetro) {
      let latSum = 0
      let lngSum = 0

      for (const coord of perimetro) {
        latSum += coord.lat
        lngSum += coord.lng
      }

      const center = {
        lat: latSum / perimetro.length,
        lng: lngSum / perimetro.length,
      }

      return center
    },
    clearInput() {
      this.search = ''
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
  },
}
</script>

<style lang="scss" scoped>
#map {
  padding: 15%;
}

.perimetro-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ececec;
        }

        &:not(:last-child) {
          border-right: 1px solid #ececec;
        }
      }
    }
  }

  .map-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .search {
      flex: 1;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      legend {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
        line-height: 21.82px;
        color: #606264;
      }

      .input {
        box-sizing: border-box;
        padding: 0.625rem;
        border: 1px solid #eaeaea;
        border-radius: 4px;
        outline: 0;
        font-size: 1rem;
        font-weight: 600;
        line-height: 21.82px;

        &::placeholder {
          color: #d3d3d3;
        }

        &:disabled {
          cursor: not-allowed;
        }

        &:-webkit-autofill {
          box-shadow: 0 0 0px 1000px white inset !important;
          -webkit-box-shadow: 0 0 0px 1000px white inset !important;
        }
      }
    }
  }
}
</style>
